module.exports = __webpack_public_path__ + "static/media/cat.1110db97.mp3";